module.exports = {
    MODEL_URL: './deeplabv3-mobile-single1_224_2_saved_js/model.json',
    // MODEL_URL: './literaspp20.5_224_2_js/model.json',
    CROP_SIZE: 224
};